import { ThemeModel } from '@/domain/models'
import { GetTheme } from '@/domain/usecases'
import { RemoteGetTheme } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeGetTheme = (): GetTheme => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<ThemeModel>()

  return new RemoteGetTheme(url, httpClient)
}
